module.exports = __webpack_public_path__ + "img/ic_home_online.588f60b3.png";